import { UserContext } from "../contexts/AuthContext";
import { useContext } from "react";

export const useAuth = () => {
    const context = useContext(UserContext);

    return context;
};
